module.exports = __webpack_public_path__ + "img/company-value.b6330af6.png";